module.exports = __webpack_public_path__ + "img/1148.fb912ca5.gif";